import { Tooltip } from "@mui/material";
import ToggleButton from "@mui/material/ToggleButton";
import GetApp from "@mui/icons-material/GetApp";
import * as FileSaver from "file-saver";
import ExcelJS from "exceljs";

const TrackHcaExportFile = ({ csvData, fileName }) => {
  const fileExtension = ".xlsx";

  const getExportStatusLabel = (status) => {
    const normalized = String(status || "")
      .trim()
      .replace(/[_-]+/g, " ")
      .replace(/\s+/g, " ")
      .toUpperCase()
      .replace("NOTFOUND", "NOT FOUND");

    return normalized
      .toLowerCase()
      .split(" ")
      .filter(Boolean)
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  const getExportEphStatusLabel = (ephStatus) => {
    if (ephStatus === true || ephStatus === "true") {
      return "Success";
    }

    if (ephStatus === false || ephStatus === "false") {
      return "Failed";
    }

    return ephStatus ?? "";
  };

  const getExportOktaPassportValue = (record) => record?.okta_id || record?.passport_id || "";

  const exportToCSV = async (records, exportFileName) => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("HCA Requests");

    // Define table columns in the same order as displayed in the UI
    const tableColumns = [
      { header: "Request ID", key: "request_id" },
      { header: "HCP Enterprise ID", key: "hcp_enterprise_id" },
      { header: "Status", key: "status" },
      { header: "EPH Status", key: "eph_status" },
      { header: "Okta ID/Passport ID", key: "okta_id" },
      { header: "One Key ID", key: "one_key_id" },
      { header: "Created Date", key: "created_date" },
      { header: "Updated Date", key: "updated_date" },
    ];

    if (!Array.isArray(records) || records.length === 0) {
      worksheet.columns = [{ header: "Info", key: "Info" }];
      worksheet.addRow({ Info: "No records found" });
    } else {
      worksheet.columns = tableColumns;
      records.forEach((record) => {
        const row = {};
        tableColumns.forEach((col) => {
          if (col.key === "status") {
            row[col.key] = getExportStatusLabel(record?.[col.key]);
          } else if (col.key === "eph_status") {
            row[col.key] = getExportEphStatusLabel(record?.[col.key]);
          } else if (col.key === "okta_id") {
            row[col.key] = getExportOktaPassportValue(record);
          } else {
            row[col.key] = record?.[col.key] ?? "";
          }
        });
        worksheet.addRow(row);
      });

      worksheet.columns.forEach((column) => {
        const maxLen = Math.max(
          column.header.length,
          ...records.map((row) => String(row?.[column.key] ?? "").length),
        );
        column.width = Math.max(18, maxLen + 2);
      });

      worksheet.autoFilter =
        worksheet.getColumn(1).letter +
        "1:" +
        worksheet.getColumn(worksheet.columns.length).letter +
        (records.length + 1);
    }

    const buffer = await workbook.xlsx.writeBuffer();
    const data = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
    });
    FileSaver.saveAs(data, exportFileName + fileExtension);
  };

  return (
    <ToggleButton
      value="list"
      size="small"
      className="border-0 float-end"
      aria-label="list"
      onClick={() => exportToCSV(csvData, fileName)}
    >
      <Tooltip disableFocusListener title="Export" id="tooltip">
        <GetApp />
      </Tooltip>
    </ToggleButton>
  );
};

export default TrackHcaExportFile;